import { Text } from "@overmap-ai/blocks"
import { computeModelIndex, type FormSubmission } from "@overmap-ai/common"
import { selectFormById, selectFormSubmissionById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"

interface FormSubmissionIndexProps extends BaseIndexLabelProps {
	formSubmissionId: FormSubmission["uuid"]
}

export const FormSubmissionIndexLabel = memo((props: FormSubmissionIndexProps) => {
	const { className, formSubmissionId, ...rest } = props

	const formSubmission = useAppSelector(selectFormSubmissionById(formSubmissionId))!
	const form = useAppSelector(selectFormById(formSubmission.form))!

	return (
		<Text className={cx("shrink-0 text-nowrap", className)} {...rest}>
			{computeModelIndex(form, formSubmission)}
		</Text>
	)
})
FormSubmissionIndexLabel.displayName = "FormSubmissionIndexLabel"
